import React, { Component, useState, useEffect } from 'react';
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, Icon } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';



function FollowUpAssessment_questionaire(props) {
  const handleClose = () => {
    window.location.href = '/dashboard';
  };
  const iframeSrc = `/FollowUpAssessment${window.location.search || ''}`;

  return (
    <Grid container xs={12} style={{ background: "linear-gradient(90deg, #dce4eb, #d7d4cf)", minHeight: "100vh", height: "100vh", position: "relative", display: "flex", flexDirection: "column" }} className="App">
      <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center" }}>
        <iframe
          style={{
            width: "100vw",
            height: "calc(100vh - 56px + 48px)", // 56px for copyright box, 48px for top padding
            border: "none",
            boxSizing: "border-box",
            display: "block"
          }}
          src={iframeSrc}
          allowFullScreen
        />
      </div>
      
    </Grid>
  );
}

function onSubmit(values) {
  console.log(values)
}

export default FollowUpAssessment_questionaire;

//<iframe width="100%" height="1200" src="https://virtusphysio.typeform.com/to/G9rBQl" frameborder="0" allowfullscreen></iframe>

//<div>
//<label>First name</label><br />
//<input type="text" name="firstname" id="firstname"/><br /><br />
//</div>